import { render, staticRenderFns } from "./BaseEditDataTable.vue?vue&type=template&id=616c0670"
import script from "./BaseEditDataTable.vue?vue&type=script&lang=js"
export * from "./BaseEditDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports